import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const SkillsFrameworksNoSuggestions = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.skillsFrameworks" });

  return <Typography variant="bodyRegular">{t("noSkillsFrameworksSuggestions")}</Typography>;
};
